import styled from '@emotion/styled';
import { useUserContext } from '../../../contexts/UserContext';
import theme from '../../../styles/theme';
import { Avatar, Text } from '../../atoms';

const UserCard = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: ${theme.spacing.xl} 0 ${theme.spacing.s} 0;
  gap: ${theme.spacing.s};
`;

const UserInfo = styled.div`
  display: flex;
  justify-content: space-around;
  margin-left: 6px;
  margin-right: auto;
  gap: ${theme.spacing.s};
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const SettingsUser = () => {
  const {
    user: { username, email },
  } = useUserContext();

  return (
    <UserCard>
      <UserInfo>
        <Avatar size="md" src="https://picsum.photos/200" alt="settingAvater" />
        <TextArea>
          <Text size="base" color={theme.colors.fontBase}>
            {username}
          </Text>
          <Text size="base" color={theme.colors.gray600}>
            {email}
          </Text>
        </TextArea>
      </UserInfo>
    </UserCard>
  );
};

export default SettingsUser;
